import '../styles/shell.css';

import { initConsent } from './site/consent';
import { initSiteShell } from './site/shell';
import { initOverlayCopy } from './site/copy';
import { bootApp } from './viewer/boot';

async function main(): Promise<void> {
  if (typeof window !== 'undefined') {
    window.__atlasExportDefaults = {
      imageLayerName: 'Octopus image',
      segmentationLayerName: 'Segmentation Labels',
      readMipImage: 1,
      readMipSeg: 1,
      marginVoxSeg: [16, 16, 8],
      saveImage: true,
      saveSeg: true,
      saveMask: false,
      maskAs1Bit: false,
      maskPerSlice: false,
      saveCsv: false,
      csvMaxRows: null,
      segZeroNonSelected: true,
      segArrayDtype: 'uint16',
      transposeXY: true,
      compression: 'zlib',
      predictor2: true,
      memoryBudgetGB: 3.0,
      wholeSaveStack: true,
      wholeCastDtype: 'source',
      ...window.__atlasExportDefaults,
    };
  }

  initConsent();
  initSiteShell();
  initOverlayCopy();

  try {
    await bootApp();
  } catch (error) {
    console.error('[Bootstrap] Failed to initialise application:', error);
  }
}

void main();
